export default __webpack_public_path__ + "d61cb55f765e68ea1c9ff3de6052b982.jpg";